var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 33.4684C26.1087 33.4684 33.639 25.9763 33.639 16.7342C33.639 7.49216 26.1087 0 16.8195 0C7.53036 0 0 7.49216 0 16.7342C0 25.9763 7.53036 33.4684 16.8195 33.4684Z",
    fill: "#2F9E44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9768 13.5675H12.5362C12.5362 12.4248 11.6015 11.4948 10.453 11.4948C9.30455 11.4948 8.36977 12.4248 8.36977 13.5675H6.9292C6.9292 11.6342 8.50983 10.0615 10.453 10.0615C12.3962 10.0615 13.9768 11.6342 13.9768 13.5675Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3796 13.3931H25.9391C25.9391 12.2505 25.0043 11.3204 23.8558 11.3204C22.7074 11.3204 21.7726 12.2505 21.7726 13.3931H20.332C20.332 11.4598 21.9127 9.88718 23.8558 9.88718C25.799 9.88718 27.3796 11.4598 27.3796 13.3931Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2541 20.0976C23.2541 23.5462 20.2682 26.3419 16.5851 26.3419C12.902 26.3419 9.91602 23.5462 9.91602 20.0976C14.3882 18.5425 18.8348 18.5234 23.2533 20.0976H23.2541Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_917_28727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 18,
    width: 15,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2541 20.0976C23.2541 23.5462 20.2682 26.3419 16.5851 26.3419C12.902 26.3419 9.91602 23.5462 9.91602 20.0976C14.3882 18.5425 18.8348 18.5234 23.2533 20.0976H23.2541Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_917_28727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7478 31.2437C19.3371 31.2437 21.4361 29.4815 21.4361 27.3078C21.4361 25.134 19.3371 23.3718 16.7478 23.3718C14.1586 23.3718 12.0596 25.134 12.0596 27.3078C12.0596 29.4815 14.1586 31.2437 16.7478 31.2437Z",
    fill: "#F03E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/excellent.1b62ea40717183c118205bbda47a352a.svg";
export { ForwardRef as ReactComponent };